export const shopCopy = {
  fr: {
    title: 'Fiches lumière', collection: 'La collection Studio Euclides',
    intro: '17 setups, de 1 à 5 flashs. La lumière studio, une fiche à la fois.',
    preview: 'Collection en préparation', available: 'Bientôt disponible',
    launched: 'La collection est disponible', launchedNote: 'Fiches, pack et guide en français ou en portugais.', ready: 'Disponible en PDF',
    cover: 'Couverture à venir', all: 'Tous', filters: 'Nombre de flashs',
    language: 'Langue des fiches', single: 'À la fiche', selection: 'Les collections',
    detail: 'Découvrir', back: 'Toutes les fiches', free: 'Gratuit',
    freeNote: 'La fiche Rembrandt sera offerte contre e-mail à son lancement.',
    pending: 'Les PDF sont en préparation. Aucun achat ni téléchargement n’est disponible pour le moment.',
    ai: 'Illustrations générées par IA', pages: 'pages', format: 'Format A4',
    content: 'Dans ce PDF', ideal: 'Idéal pour', level: 'Niveau',
    flash: n => `${n} ${n === 1 ? 'flash' : 'flashs'}`,
    count: n => `${n} ${n === 1 ? 'fiche' : 'fiches'}`,
    range: '1 à 5 flashs', pdf: 'PDF numérique', contentsSheet: 'Une fiche dédiée à ce setup',
    contentsBundle: 'Un PDF avec sommaire', notFound: 'Cette fiche n’existe pas.',
    levels: { beginner: 'Débutant', intermediate: 'Intermédiaire', advanced: 'Avancé', expert: 'Expert', 'beginner-expert': 'Débutant à expert', 'beginner-intermediate': 'Débutant à intermédiaire' },
  },
  pt: {
    title: 'Fichas de iluminação', collection: 'A coleção Studio Euclides',
    intro: '17 setups, de 1 a 5 flashes. A luz de estúdio, uma ficha de cada vez.',
    preview: 'Coleção em preparação', available: 'Disponível em breve',
    launched: 'A coleção está disponível', launchedNote: 'Fichas, pack e guia em francês ou português.', ready: 'Disponível em PDF',
    cover: 'Capa em breve', all: 'Todos', filters: 'Número de flashes',
    language: 'Idioma das fichas', single: 'Fichas individuais', selection: 'As coleções',
    detail: 'Descobrir', back: 'Todas as fichas', free: 'Grátis',
    freeNote: 'A ficha Rembrandt será oferecida mediante e-mail no lançamento.',
    pending: 'Os PDF estão em preparação. As compras e os downloads ainda não estão disponíveis.',
    ai: 'Ilustrações geradas por IA', pages: 'páginas', format: 'Formato A4',
    content: 'Neste PDF', ideal: 'Ideal para', level: 'Nível',
    flash: n => `${n} ${n === 1 ? 'flash' : 'flashes'}`,
    count: n => `${n} ${n === 1 ? 'ficha' : 'fichas'}`,
    range: '1 a 5 flashes', pdf: 'PDF digital', contentsSheet: 'Uma ficha dedicada a este setup',
    contentsBundle: 'Um PDF com índice', notFound: 'Esta ficha não existe.',
    levels: { beginner: 'Iniciante', intermediate: 'Intermédio', advanced: 'Avançado', expert: 'Especialista', 'beginner-expert': 'Iniciante a especialista', 'beginner-intermediate': 'Iniciante a intermédio' },
  },
};

// Traductions des usages FR ; les titres, sous-titres et descriptions approuvés restent intacts.
export const idealForPT = [
  'Retratos de homem e mulher, headshots artísticos, retratos de caráter',
  'Beleza, maquilhagem, retratos femininos, headshots glamour',
  'Retratos masculinos, artistas, músicos, cartazes, ambientes escuros',
  'Retratos profissionais, LinkedIn, CV, famílias, retratos do dia a dia',
  'Retratos artísticos, gravidez, fine art, retratos escuros e elegantes',
  'Dança, desporto, gravidez de perfil, casais, cartazes',
  'Retratos profissionais, headshots, retratos clássicos de estúdio',
  'Retratos masculinos, desporto, artistas, cabelo escuro sobre fundo escuro',
  'Beleza, maquilhagem, cosmética, retratos femininos, headshots luminosos',
  'Desporto, fitness, dança, retratos masculinos, moda urbana',
  'Entrevistas, retratos profissionais, vídeo, retratos de estúdio de qualidade',
  'Retratos masculinos, desporto, cartazes, artistas, cosplay',
  'Retratos criativos, marcas, artistas, conteúdos para redes sociais',
  'Moda, e-commerce, catálogos, retratos de família luminosos, branding',
  'Retratos corporativos, equipas, artistas, retratos premium',
  'Cosmética, maquilhagem, cabeleireiro, campanhas, retratos premium',
  'Moda, dança, desporto, catálogos de luxo, marcas',
];